import type { RefObject } from 'react'
import { Search, X } from 'lucide-react'

export type PanelSearchBarProps = {
  inputRef: RefObject<HTMLInputElement | null>
  value: string
  onChange: (q: string) => void
  onClose: () => void
  placeholder?: string
  resultCount?: number
  totalCount?: number
  /** Noun after the counts. Folder browse uses documents. */
  countNoun?: string
  'data-testid'?: string
}

export function PanelSearchBar({
  inputRef,
  value,
  onChange,
  onClose,
  placeholder = 'filter...',
  resultCount,
  totalCount,
  countNoun = 'documents',
  'data-testid': dataTestId,
}: PanelSearchBarProps) {
  const showCounts =
    typeof resultCount === 'number' && typeof totalCount === 'number'

  return (
    <div
      className="flex items-center gap-2 px-3 py-1.5 border-b border-border bg-muted/20 shrink-0"
      data-testid={dataTestId}
    >
      <Search className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <span className="text-xs text-muted-foreground/60 shrink-0 select-none">search:</span>
      <input
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 bg-transparent text-sm outline-none text-foreground placeholder:text-muted-foreground/40 min-w-0"
      />
      {showCounts && (
        <span className="text-xs text-muted-foreground/60 shrink-0 select-none whitespace-nowrap">
          {resultCount} of {totalCount} {countNoun}
        </span>
      )}
      <button
        type="button"
        onClick={onClose}
        className="text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Close search"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
